// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_br-b";
export var colorBlue = "_br-8";
export var colorDot = "_br-0";
export var colorDotLarge = "_br-2";
export var colorDotSmall = "_br-1";
export var colorGreen = "_br-7";
export var colorGrey = "_br-3";
export var colorOrange = "_br-5";
export var colorPink = "_br-a";
export var colorPurple = "_br-9";
export var colorRed = "_br-4";
export var colorYellow = "_br-6";